import styled from "styled-components";

export const Forms = styled.form`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 4px;
    width: 100%;
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 4px;

    padding: 10px;
    background-color: ${(props) => props.theme.colors.white};

    div{
        display: flex;
        align-items: center;
        gap: 4px;
    }
    
    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_50};
    }
`;

export const FormsInputs = styled.div`
    display: flex;
    flex-direction: column;
    padding: 4px;

    width: 100%;

    background-color: ${(props) => props.theme.colors.white};
    border-radius: 4px;
`;

export const Input = styled.input`
    padding: 10px;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_100};

    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }

    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
`;

export const Label = styled.label`
    span{
        color: ${(props) => props.theme.colors.error};
    }
`;

export const Section = styled.div`
    display: flex;
    gap: 8px;

    width: 100%;
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_100};
    padding: 10px;

    width: 100%;

    &:focus-within {
        border-radius: 4px;
        border: 1px solid ${(props) => props.theme.colors.gray.gray_200};
        box-shadow: 0 0 0 3px ${(props) => props.theme.colors.gray.gray_50};
        transform: translateY(-1px);
    }
`;

export const Text = styled.p``;